import React, { useEffect, useState } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    Show,
    SelectArrayInput,
    List,
    TextField,
    NumberField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
    BooleanField,
    DateField,
} from 'react-admin';

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}


export const ModelSchemaList = () => {

    return (
        <List
            actions={<ListActions/>}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name"  />
                <DateField source="createdAt" />
                <DateField source="updatedAt" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
